<template>
	<div id="app">
		<el-container>
			<el-header v-if="currentRoute != '/login' && currentRoute != '/404'">
				<headerBlock />
			</el-header>

			<el-container>
				<el-aside  v-if="currentRoute != '/login' && currentRoute != '/404'">
					<siteBar />
				</el-aside>
				<el-main>
					<router-view/>
				</el-main>
			</el-container>

		</el-container>
	</div>
</template>


<script>
import Vue from 'vue'
import siteBar from '@/components/sitebar'
import headerBlock from '@/components/header'
import sass from './sass/main.sass'
import { mapGetters } from 'vuex';
import VueCookies from 'vue-cookies'
import vgloballayout from '@/components/appGlobalLayout'

Vue.use(VueCookies)
Vue.component('vgloballayout', vgloballayout)

export default {
	data() {
		return {
			currentRoute: this.$route.path,
			toketValid: true
		}
	},
	computed: {

	},
	mounted() {
		//let dateExp = new Date() / 1000
		//this.toketValid = dateExp < window.$cookies.get('time_token_die_adminOrg')
	},
	components: {
		siteBar, headerBlock
	},
	watch: {
		'$route' (to) {
			this.currentRoute = to.path
		}
	}
}
</script>

<style>
	body {
		font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei",Arial,sans-serif;
		margin: 0 auto;
		padding: 0;
	}

	.el-header {
		background-color: #FFF;
		color: #333;
		line-height: 60px;
		border-bottom: 1px solid #CCC;
	}
	
	.el-aside {
		color: #333;
	}

	#app {
		margin: 0 auto;
		display: flex;
		justify-content: center;
	}
</style>
